var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0542 90H29V81.9431H92.0542V90ZM31.1018 87.8982H89.9524V84.0449H31.1018V87.8982Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0542 52.1741H29V44.4955L60.5271 30L92.0542 44.4955V52.1741ZM31.1018 50.0723H89.9524V45.8406L60.5271 32.312L31.1018 45.8406V50.0723Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1131 79.8763H35.3047V55.2408H45.1131V79.8763ZM37.4065 77.7745H43.0113V57.3427H37.4065V77.7745Z",
    fill: "#00A3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7498 79.8763H75.9414V55.2408H85.7498V79.8763ZM78.0432 77.7745H83.648V57.3427H78.0432V77.7745Z",
    fill: "#00A3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5151 84.0446H33.9043V77.7742H46.5151V84.0446ZM36.0061 81.9428H44.4133V79.876H36.0061V81.9428Z",
    fill: "#00A3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1499 84.0446H74.5391V77.7742H87.1499V84.0446ZM76.6409 81.9428H85.0481V79.876H76.6409V81.9428Z",
    fill: "#00A3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5275 47.1297C57.8652 47.1297 55.6934 44.9579 55.6934 42.2956C55.6934 39.6333 57.8652 37.4614 60.5275 37.4614C63.1898 37.4614 65.3617 39.6333 65.3617 42.2956C65.3617 44.9579 63.1898 47.1297 60.5275 47.1297ZM60.5275 39.5562C59.0212 39.5562 57.7952 40.7823 57.7952 42.2886C57.7952 43.7949 59.0212 45.0209 60.5275 45.0209C62.0338 45.0209 63.2599 43.7949 63.2599 42.2886C63.2599 40.7823 62.0338 39.5562 60.5275 39.5562Z",
    fill: "#2DCDAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4315 79.8763H55.623V55.2408H65.4315V79.8763ZM57.7249 77.7745H63.3297V57.3427H57.7249V77.7745Z",
    fill: "#00A3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8335 84.0446H54.2227V77.7742H66.8335V84.0446ZM56.3245 81.9428H64.7317V79.876H56.3245V81.9428Z",
    fill: "#00A3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 118,
    height: 118,
    rx: 31,
    stroke: "#09547E",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox1);
export default __webpack_public_path__ + "static/media/box1.8c52e319aec962148de4263d5b66b9d6.svg";
export { ForwardRef as ReactComponent };